import isEmpty from './Empty';

// undefined, false, ”, ‘ ’, null, [], and {}
const isBlank = value => {
  if (typeof value === 'undefined' || (typeof value !== 'number' && !value) || value === '' || value === ' ' || value === null || isEmpty(value)) {
    return true
  } else {
    return false
  }
}

export default isBlank;
